import api, { API_BASE, defaultOpt } from "./apiService";
import { filterTable, rowTransform } from "./tableUtils";

export async function getAllTape() {
  return (await api.get(`${API_BASE}/list-tape`)).data;
}

export async function addTape(form) {
  return (await api.post(`${API_BASE}/add-tape`, form, defaultOpt())).data;
}

export async function deleteTape(id) {
  return (await api.delete(`${API_BASE}/delete-tape/${id}`, defaultOpt())).data;
}

export async function updateTape(id, form) {
  return (await api.put(`${API_BASE}/update-tape/${id}`, form, defaultOpt()))
    .data;
}

const __map__ = {
  FL0: "LD Full",
  FH0: "HD Full",
  BL0: "LD Bottom",
  TL0: "LD Top",
  "5L0": "LD Five",
  LL0: "LD Left",
  RL0: "LD Right",
  LHW: "CEE HD Left",
  RHW: "CEE HD Right",
  BHW: "CEE HD Bottom",
  THT: "CEH HD Top",
};

export function tapeGeometryDisplay(type) {
  return type in __map__ ? __map__[type] : "UNKNOWN";
}

export const tapeGeometryOptions = Object.keys(__map__).map((key) => ({
  value: key,
  label: `(${key}) ${__map__[key]}`,
}));

const __s_map__ = {
  LEIT: "Leiton",
  OMKL: "OM-Klebetechnik (CERN)",
  INST: "Institute",
};

export function tapeSourceDisplay(source) {
  return source in __s_map__ ? `[${source}] ${__s_map__[source]}` : "UNKNOWN";
}

export const tapeSourceOptions = Object.keys(__s_map__).map((key) => ({
  value: key,
  label: __s_map__[key],
}));

export function makeTapeOptions(tapeList, bpType, hideExhaust = false) {
  let options = filterTable(tapeList, (tape) =>
    hideExhaust ? tape.available > 0 : true,
  );
  options = filterTable(options, (tape) => {
    if (!bpType) return true;
    if (bpType[0] === "F") return tape.type[0] === "F";
    if (bpType[0] === "S") return tape.type[1] === bpType[1];
    return tape.type.substring(0, 2) === bpType.substring(0, 2);
  });
  return rowTransform(options, (tape) => ({
    value: tape.id,
    label: `${tape.batch_id} (${tape.type}: ${tapeGeometryDisplay(tape.type)})`,
    available: tape.available > 0,
  }));
}

export function tapeDescription(tapeList, id) {
  const tape = filterTable(tapeList, (tape) => tape.id === id);
  return tape ? `${tape.batch_id}:${tape.type}` : "";
}
